<script setup lang="ts">
import { computed, useSlots } from 'vue'

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'active'

const props = withDefaults(defineProps<{
  variant?: BadgeVariant
  bgColor?: string
  textColor?: string
}>(), {
  variant: 'default'
})

const slots = useSlots()
const hasContent = computed(() => !!slots.default)

const variantColors: Record<BadgeVariant, { bg: string; text: string }> = {
  default: { bg: 'bg-metal-600', text: 'text-metal-300' },
  success: { bg: 'bg-green-500/20', text: 'text-green-400' },
  warning: { bg: 'bg-yellow-500/20', text: 'text-yellow-400' },
  danger: { bg: 'bg-red-500/20', text: 'text-red-400' },
  info: { bg: 'bg-blue-500/20', text: 'text-blue-400' },
  active: { bg: 'bg-cyan-500/20', text: 'text-cyan-400' }
}

const badgeClass = computed(() => {
  const colors = variantColors[props.variant]
  const bg = props.bgColor || colors.bg
  const text = props.textColor || colors.text
  return `px-1.5 py-0.5 text-xs font-medium rounded ${bg} ${text}`
})
</script>

<template>
  <span v-if="hasContent" :class="badgeClass"><slot /></span>
</template>
